module.exports = "<div class=\"dashEmp\">\r\n    <app-list></app-list>\r\n</div>"